import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import homeData from "./home-data";
import HeroSectionHome from "../../components/HeroSection/HeroSectionHome";
import FeatureTextSection from "../../components/FeatureTextSection/FeatureTextSection";
import InformationCard from "../../components/InformationCard/InformationCard";
import CategoryFeatureCard from "../../components/CategoryFeatureCard/CategoryFeatureCard";
import QualityCard from "../../components/QualityCard/QualityCard";

const HomePage = () => {
  const [heroSectionHome, setHeroSectionHome] = useState({});
  const [welcomeTextSection, setWelcomeTextSection] = useState({});
  const [whyChooseUs, setWhyChooseUs] = useState([]);
  const [ourProductsSection, setOurProductsSection] = useState({});
  const [categoryFeatureCard, setCategoryFeatureCard] = useState([]);
  useEffect(() => {
    setHeroSectionHome(homeData.hero_section_home);
    setWelcomeTextSection(homeData.welcome_text_section);
    setWhyChooseUs(homeData.why_choose_us);
    setOurProductsSection(homeData.our_products_section);
    setCategoryFeatureCard(homeData.category_feature_card);
  }, []);

  return (
    <div className="home-page">
      <HeroSectionHome
        title={heroSectionHome.title}
        titleClassName="text-white"
        brand={heroSectionHome.brand}
        description={heroSectionHome.description}
        video={heroSectionHome.src}
      />

      <section className="feature-text-section text-[#2c3e50]">
        <FeatureTextSection
          title={welcomeTextSection.title}
          minisubline={welcomeTextSection.minisubline} color="text-[#ff6b35]"
          description={welcomeTextSection.description}
          className="bg-gray-100 py-20 text-center"
        />
      </section>

      <section className="features-card-info-section bg-gray-100">
        <h2 className="text-4xl md:text-5xl font-extrabold py-8 text-[#2c3e50] ">Why Choose Us</h2>
        <div className="max-w-screen-xl mx-auto">
          <Row
            gutter={16}
            className="flex flex-wrap justify-center h-full py-12"
          >
            {whyChooseUs.map((feature, idx) => (
              <Col
                xs={24}
                sm={12}
                md={8}
                lg={6}
                key={idx}
                className="gap-4 mb-3"
              >
                <InformationCard
                  feature={feature}
                  customClassName="bg-white h-full w-full"
                />
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="features-section bg-gray-100">
        <div className="w-3/4 mx-auto">
          <section className="our-products-section text-[#2c3e50]">
            <FeatureTextSection
              title={ourProductsSection.title}
              description={ourProductsSection.description}
            />
            <Row gutter={16} className="flex flex-wrap justify-center">
              {categoryFeatureCard.map((card, idx) => (
                <Col key={idx} className="mb-8">
                  <CategoryFeatureCard
                    image={card.image}
                    title={card.title}
                    description={card.description}
                    features={card.features}
                    link={card.link}
                  />
                </Col>
              ))}
            </Row>
          </section>
        </div>

        <section className="zestymark-section bg-gray-100 py-12">
          <div className="flex flex-col items-center w-full">
            <div className="perspective-1000">
              <img
                className="h-64 w-64 mb-6 animate-rotateY transform-style-preserve-3d"
                src="/media/Zestymark.webp"
                alt="Zestymark"
              />
            </div>

            <div className="w-full">
              <section className="zestymark-section text-[#2c3e50]">
                <FeatureTextSection
                  title={"The Zesty Mark - A Symbol of Trusted Freshness"}
                  description={
                    "At Zesty Tongue, every product that carries the Zesty Mark represents more than just a label—it's a promise. A promise that what you're about to serve or enjoy has passed through rigorous quality checks, premium sourcing, and expert preparation. The Zesty Mark is our signature seal, applied only to those products that meet our uncompromising standards for freshness, flavor, and food safety."
                  }
                />
                <QualityCard
                  features={homeData.zestyMark.features}
                  tagline={homeData.zestyMark.tagline}
                />
                <h3 className="text-center text-2xl md:text-3xl font-bold pt-10 pb-10">
                  "Look for the Zesty Mark - Your Taste, Our products"
                </h3>
              </section>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
};

export default HomePage;
